import PhatDropdown from 'components/formElements/PhatDropdown'

type Props = {
  value?: number
  onChange: (value: number) => void
}

const SortingDropdown = ({ value = 0, onChange }: Props) => (
  <PhatDropdown
    header="Filter to my collection:"
    inlineHeader
    options={[
      { label: 'Off', onClick: () => onChange(0), id: `${0}` },
      { label: 'Paper', onClick: () => onChange(1), id: `${1}` },
      { label: 'MTGO', onClick: () => onChange(2), id: `${2}` },
      { label: 'Arena', onClick: () => onChange(3), id: `${3}` },
    ]}
    value={`${value}`}
  />
)

export default SortingDropdown
